import { IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTranslation } from '../../hooks/useTranslation';

const focusRingSx = {
	'&:focus-visible, &.Mui-focusVisible': {
		outline: '2px solid #3053D3',
		outlineOffset: '2px',
	},
};

const baseSx = {
	flexShrink: 0,
	width: 44,
	height: 44,
	boxSizing: 'border-box',
	...focusRingSx,
};

function BackIconButton({ onClick, sx, iconSx, color, disabled, ...rest }) {
	const { t } = useTranslation();

	return (
		<IconButton
			type="button"
			disabled={disabled}
			disableRipple
			aria-label={t('common.buttons.back')}
			onClick={onClick}
			sx={{ ...baseSx, ...sx }}
			{...rest}
		>
			<ArrowBackIcon color={color} sx={{ fontSize: '1.5rem', ...iconSx }} />
		</IconButton>
	);
}

export default BackIconButton;
